import { Mail, MapPin, Sparkles } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/10 bg-white/[0.02]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-md bg-gradient-to-br from-indigo-500 to-indigo-700 shadow-[0_0_20px_rgba(99,102,241,0.5)]">
              <Sparkles className="w-4 h-4 text-white" />
            </span>
            <span className="font-display text-lg text-white">
              Recruit<span className="text-indigo-400">Steps</span> / AI
            </span>
          </div>
          <p className="text-sm text-slate-400 max-w-xs leading-relaxed">
            Engineering the future with AI automation and elite specialized
            talent — for the world&rsquo;s most demanding industries.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-slate-400 mb-4">
            Explore
          </div>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><a href="#services" className="hover:text-white transition-colors">Solutions</a></li>
            <li><a href="#founder" className="hover:text-white transition-colors">Founder</a></li>
            <li><a href="#impact" className="hover:text-white transition-colors">Impact</a></li>
            <li><a href="#contact" className="hover:text-white transition-colors">Contact</a></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-slate-400 mb-4">
            Reach us
          </div>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-indigo-400" />
              hello@recruitsteps.ai
            </li>
            <li className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-indigo-400" />
              Global · Remote-first
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} RecruitSteps &amp; AI Solutions. All rights reserved.</span>
          <span>Engineered with intent · Built for enterprise</span>
        </div>
      </div>
    </footer>
  );
}
